import React from 'react';
import { Page } from '../Page';
import { Dumbbell, TrendingUp, Zap } from 'lucide-react';
export function SupplementAshwagandhaMuscle() {
  return <Page pageNumber={28} variant="light" data-id="element-2977">
      <div className="flex h-full gap-10" data-id="element-2978">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-2979">
          <img src="https://cdn.magicpatterns.com/uploads/d3YyBiJkGkHonv19FV4VGU/pasted-image.png" alt="Thorne Ashwagandha" className="w-full max-w-[280px] object-contain" data-id="element-2980" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-2981">
          <div className="mb-6 pt-4" data-id="element-2982">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2983">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2984">
              Ashwagandha
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2985">
              Support testosterone and lean muscle retention
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-2986" />
          </div>

          <div className="mb-8" data-id="element-2987">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-2988">
              Why It Matters for Exercise on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-2989">
              Research shows ashwagandha supports healthy testosterone levels,
              which promotes lean muscle retention during weight loss, a
              critical concern on GLP-1 medications where up to 30-40% of weight
              lost can be lean mass. By modulating cortisol (which has an
              inverse relationship with testosterone), ashwagandha creates a
              more favorable hormonal environment for building and preserving
              muscle.
            </p>
          </div>

          <div className="mb-8" data-id="element-2990">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-2991">
              Key Benefits for Exercise
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-2992">
              <li className="flex gap-2" data-id="element-2993">
                <TrendingUp className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2994" />
                <span data-id="element-2995">
                  Supports healthy testosterone levels, promoting muscle protein
                  synthesis and lean mass retention
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2996">
                <Dumbbell className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2997" />
                <span data-id="element-2998">
                  Enhances strength, power output, and exercise recovery in
                  clinical studies
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2999">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3000" />
                <span data-id="element-3001">
                  Lowers cortisol, reducing the catabolic hormone that breaks
                  down muscle tissue
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3002">
                <span className="text-tealslate shrink-0" data-id="element-3003">•</span>
                <span data-id="element-3004">
                  Shoden® extract at 35% withanolide glycosides, clinically
                  effective at just 1 capsule per day
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 mb-6" data-id="element-3005">
            <p className="text-xs text-[#3B3B3B] leading-[1.6] italic" data-id="element-3006">
              Pair with creatine and adequate protein intake for the strongest
              muscle-preservation strategy during GLP-1 weight loss.
            </p>
          </div>

          <div className="mt-auto" data-id="element-3007">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3008">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3009">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3010">
                <strong data-id="element-3011">1 capsule daily</strong>. Can be taken morning or
                evening
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3012">
                30 capsules per bottle • Shoden® ashwagandha extract
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3013">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3014" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3015">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}